import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetDrawerIsOpen";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Info from "@insite/mobius/Icons/Info";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomBlueExclamation from "@WhiteCap/Icons/CustomBlueExclamation";
import CustomCircleExclamation from "@WhiteCap/Icons/CustomCircleExclamation";
import CustomExclamation from "@WhiteCap/Icons/CustomExclamation";
import React from "react";
import { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {
    setDrawerIsOpen,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasShellContext;

export interface ShipFromBranchMessageStyles {
    infoMessage?: InjectableCss;
    modalIcon?: IconPresentationProps;
    message?: InjectableCss;
    info?: InjectableCss;
}

export const shipFromBranchMessageStyles: ShipFromBranchMessageStyles = {
    infoMessage: {
        css: css`
            display: flex;
            justify-content: flex-start;
            margin-bottom: 15px !important;
            font-size: 15px !important;
            border: 1px solid var(--Blue-blue-300, #80b1fa);
            height: 51px;
            align-items: center;
        `,
    },
    modalIcon: {
        size: 22,
        css: css`
            color: black;
            margin-left: 16px;
            margin-right: 10px;
        `,
    },
    message: {
        css: css`
            width: 80%;
        `,
    },
    info: {
        css: css`
            color: rgb(59 130 246);
            margin-right: 15px;
            margin-left: 15px;
            size: 24px;
        `,
    },
};
const styles = shipFromBranchMessageStyles;
const ShipFromBranchMessage: FC<Props> = () => {
    return (
        <Hidden below="lg">
            <StyledWrapper {...styles.infoMessage}>
                <Icon {...styles.modalIcon} src={CustomBlueExclamation} {...styles.info} />
                <Typography {...styles.message}>{siteMessage("ShipFromBranch_Message")}</Typography>
            </StyledWrapper>
        </Hidden>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(ShipFromBranchMessage)),
    definition: {
        displayName: "Ship From Branch Message",
        group: "Common",
    },
};

export default widgetModule;
